import { DATE_SHORT_FORMAT } from '../../../../constants/date'
import { TABLE_MODAL_CONTEXT_FLOATING } from '../../../TableModal'
import {
  getEmailThreadDateItem,
  getEmailThreadMessageItem,
} from '../../Email.utils'
import { EmailTableRowDateCreated } from '../../EmailTableRowDateCreated'
import { EmailTableRowMessage } from '../../EmailTableRowMessage'
import { EMAIL_ATTACHED_THREADS_MODAL_TABLE_CELL_NAME } from '../EmailAttachedThreadsModal.constants'
import { EmailThreadsModalTableRowParticipants } from '../EmailThreadsModalTableRowParticipants'

export function renderCell({ attachedFilesProps, item, name, ...restProps }) {
  const messageItem = getEmailThreadMessageItem(item, true)

  const dateItem = getEmailThreadDateItem(item)

  switch (name) {
    case EMAIL_ATTACHED_THREADS_MODAL_TABLE_CELL_NAME.participants:
      return (
        <EmailThreadsModalTableRowParticipants {...restProps} item={item} />
      )
    case EMAIL_ATTACHED_THREADS_MODAL_TABLE_CELL_NAME.message:
      return (
        <EmailTableRowMessage
          {...restProps}
          attachedFilesProps={attachedFilesProps}
          floatingPortalId={TABLE_MODAL_CONTEXT_FLOATING}
          item={messageItem}
        />
      )
    case EMAIL_ATTACHED_THREADS_MODAL_TABLE_CELL_NAME.date:
      return (
        <EmailTableRowDateCreated
          {...restProps}
          dateFormat={DATE_SHORT_FORMAT}
          item={dateItem}
        />
      )
  }
}
